var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({ color: _vm.amount >= 0 ? '#237804' : '#a8071a'})},[_vm._v(_vm._s(_vm.currency(_vm.amount, _vm.decimal)))])}
var staticRenderFns = []

export { render, staticRenderFns }